import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Cards from '../Cards'
function Body() {
     
    const [data,setData]=useState([])
    const [id,SetId]=useState('')

    useEffect(()=>{
      SetId(localStorage.getItem('useuserId'))
    })


     
    const Api=()=>{

        axios.get('https://tinkus.onrender.com/getUser',{
          headers: {
            'UserId': id,
           
          }
        })
        .then((result)=>{
         console.log(result.data.data)
         setData(result.data.data)
         //alert("Create SuccessFully")
        })
       .catch((err)=>{
         console.log(err)
 
         alert(err.response.data.msg)
       })

    }
     
    const [show ,unShow]=useState(true)


  return (
    <div>
   <div id='but'> <button id='butt' onClick={Api}>Get Memo List </button></div>
   <div className=''>
      
    <hr></hr>
         {
           data.map((a)=>{

              return (
                <Cards data={a} />
              )
            
           })
         }
    </div>
   </div>
  )
}

export default Body
